import { Values } from '../utils/types';
import { COLOR_PARCELS_BY, COLOR_TRACKS_BY } from './colorConstants';

export const PHYTO_TASK_TYPE = {
  PHYTO: 'phyto',
  SEMENCE: 'phyto_seed',
} as const;
export type PhytoTaskType = Values<typeof PHYTO_TASK_TYPE>;

export const TASK_STATUS = {
  TO_DO: 'todo',
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
  DRAFT: 'draft',
  TO_CREATE: 'to_link',
  BILLED: 'billed',
} as const;
export type TaskStatus = Values<typeof TASK_STATUS>;

export const FILTER_TASK_STATUS = [
  TASK_STATUS.TO_DO,
  TASK_STATUS.IN_PROGRESS,
  TASK_STATUS.DRAFT,
  TASK_STATUS.DONE,
  TASK_STATUS.BILLED,
  TASK_STATUS.ARCHIVED,
] as const;

export const DEFAULT_FILTER_TASK_STATUS = FILTER_TASK_STATUS.filter((s) => s !== TASK_STATUS.ARCHIVED);

// Tasks in these statuses should not be visible from the user's perspective
export const RESTRICTED_TASK_STATUSES = [TASK_STATUS.TO_DO, TASK_STATUS.IN_PROGRESS, TASK_STATUS.DRAFT] as const;

const TASK_METADATA_GROUP = {
  CUSTOMER: 'customer',
  CACHET: 'cachet',
  DETAILS: 'details',
  CHECK_BEFORE_WORKSITE: 'check_before_worksite',
  CHECK_AFTER_WORKSITE: 'check_after_worksite',
  WORKSITE_VALIDATION: 'worksite_validation',
} as const;

export const VISIBLE_TASK_METADATA_GROUPS = [
  TASK_METADATA_GROUP.CUSTOMER,
  TASK_METADATA_GROUP.DETAILS,
  TASK_METADATA_GROUP.CHECK_BEFORE_WORKSITE,
  TASK_METADATA_GROUP.CHECK_AFTER_WORKSITE,
  TASK_METADATA_GROUP.WORKSITE_VALIDATION,
] as const;
export type VisibleTaskMetadataGroups = (typeof VISIBLE_TASK_METADATA_GROUPS)[number];

export const TASK_METADATA_QUESTION_TYPE = {
  STRING: 'string',
  NUMBER: 'int',
  DATE: 'date',
} as const;
export type TaskMetadataQuestionType = Values<typeof TASK_METADATA_QUESTION_TYPE>;

export const TASK_METADATA_QUESTION_FORMAT = {
  SINGLE_CLOSED: 'single_closed',
  MULTI_CLOSED: 'multi_closed',
  OPEN: 'open',
  YES_OR_NO: 'yes_or_no',
  CUSTOMER: 'customer',
  USER: 'user',
  ADMIN: 'admin',
} as const;
export type TaskMetadataQuestionFormat = Values<typeof TASK_METADATA_QUESTION_FORMAT>;

export const TASK_METADATA_SUMMARY_QUESTIONS = [
  'znt_to_consider',
  'filling_place',
  'anti_drift_nozzles_usage',
  'rinsing_place',
];

export const TASK_PDF_MAP_BACKGROUND = {
  SATELLITE: 'satellite',
  ROADMAP: 'roadmap',
  TERRAIN: 'terrain',
} as const;

export type TaskPDFMapBackground = Values<typeof TASK_PDF_MAP_BACKGROUND>;

export const DEFAULT_PDF_OPTIONS = {
  EQUIPMENT_SESSION_TRACKS: true,
  PARCEL_SESSION_TRACKS: true,
  PARCEL_DETAILS: true,
  MAP_BACKGROUND: TASK_PDF_MAP_BACKGROUND.ROADMAP,
  TRACK_COLOR: COLOR_TRACKS_BY.DEFAULT,
  PARCEL_COLOR: COLOR_PARCELS_BY.DEFAULT,
  INSTRUCTIONS: true,
  OBSERVATIONS: true,
} as const;
